import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';


import "../styles/dataTable.css";
import searchIcon from '../assets/images/search_icon.svg';
import addIcon from '../assets/images/add-icon.svg';
import arrowIcon from '../assets/images/Arrow.svg';
import upwardArrowIcon from '../assets/images/upward_arrow.svg';
import editIcon from '../assets/images/edit_icon.svg';
import CreatePackageInPage from './CreatePackageInPage';
import UpdatePackageInPage from './UpdatePackageInPage';

const ExpiredPackage = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  
  // Safely retrieve vendor ID from localStorage
  const getVendorId = () => {
    try {
      const vendorData = localStorage.getItem("vendor");
      return vendorData ? JSON.parse(vendorData)?.id : null;
    } catch (error) {
      console.error("Error reading vendor from localStorage:", error);
      return null;
    }
  };

  const [vendors, setVendors] = useState([]);
  const [categories, setCategories] = useState([]);

  const [showCreatePackage, setShowCreatePackage] = useState(false);
  const [showUpdatePackage, setShowUpdatePackage] = useState(false);
  const containerRef = useRef(null);
  const containerUpdateRef = useRef(null);

  const [cardId, setCardId] = useState(null);

  // Table State
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredData = cards.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA || "").localeCompare(String(valB || ""))
          : String(valB || "").localeCompare(String(valA || ""));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  // Sort Toggle Handler
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  useEffect(() => {
    fetchVendor();
    fetchCategory();
    fetchExpiredCards();
  }, [showCreatePackage, showUpdatePackage]);



  const fetchVendor = async () => {
    try {
      const response = await api.get('/vendor/get-all');
      setVendors(response.data.data || []);
    } catch (error) {
      console.error('Error fetching vendor data:', error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await api.get('/page/get-all');
      setCategories(response.data.data || []);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  // ✅ FETCH EXPIRED PACKAGES FROM SPECIFIC ENDPOINT
  const fetchExpiredCards = async () => {
    const vendorId = getVendorId();
    if (!vendorId) {
      console.error("Vendor ID not found");
      return;
    }

    try {
      const response = await api.get(`api/Vendorlist/expiredpackages/${vendorId}`);
      setCards(response.data.data || []);
    } catch (error) {
      console.error('Error fetching expired package data:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cards/${id}`);
      setCards(cards.filter(card => card.id !== id));
      alert(`Package with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Error deleting package');
    }
  };

  function handlePackageUpdate(id) {
    setCardId(id);
    setShowUpdatePackage(true);
  }

  const handleCreatePackageClick = () => {
    setShowCreatePackage(true);
  };

  return (
    <div style={{ position: 'relative', height: showCreatePackage || showUpdatePackage ? "100vh" : 'auto', overflow: 'hidden' }}>

      <div style={{ padding: "20px", opacity: showCreatePackage || showUpdatePackage ? 0 : 1 }}>
        {/* Table Header */}
        <div className="table-header">
          <h2 style={{ fontWeight: 700 }}>Expired Package List</h2>

          <div className="search-container">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="search"
            />
            <img src={searchIcon} alt="search-icon" className="search-icon" />
          </div>

          <div className="entries-container">
            <label htmlFor="noOfEntries">Show: </label>
            <select
              value={entriesPerPage}
              id="noOfEntries"
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries per page</option>
              <option value={50}>50 Entries per page</option>
              <option value={100}>100 Entries per page</option>
            </select>
          </div>


        </div>

        {/* Table */}
        <table id="expiredPackageTable" width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              <th onClick={() => handleSort("category_id")}>
                <div className='name-container'>
                  Pilgrimage Type
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={{ opacity: sortField === "category_id" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{
                      transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "category_id" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>

              <th onClick={() => handleSort("duration")}>
                <div className='name-container'>
                  Duration
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={{ opacity: sortField === "duration" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{
                      transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "duration" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>

              <th onClick={() => handleSort("price")}>
                <div className='name-container'>
                  Price
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={{ opacity: sortField === "price" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{
                      transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "price" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>

              
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((card, i) => {
                return (
                  <tr key={card.id}>
                    <td>{categories?.filter(el => el.id === card.category_id)[0]?.name || "N/A"}</td>
                    <td>{card.duration}</td>
                    <td>₹ {parseFloat(card.price || 0).toLocaleString('en-IN')}</td>
                    <td>
                      <span style={{ color: "#d9534f", fontWeight: "600" }}>Expired</span>
                    </td>
                    <td className='text-center align-middle'>
                      <button className='edit-button' onClick={() => handlePackageUpdate(card.id)}>
                        <img src={editIcon} alt="editIcon" />
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  No expired packages found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div style={{ paddingBottom: '30px', background: '#fff' }}>
          <div style={{ padding: "30px", textAlign: "center", borderTop: '2px solid #F2F2F2', borderBottom: '2px solid #F2F2F2' }}>
            {/* Prev arrow */}
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                margin: "0 5px",
                padding: "5px 10px",
                background: "#fff",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                color: currentPage === 1 ? "#ccc" : "#000"
              }}
            >
              <img src={arrowIcon} alt="arrow-icon"
                style={{
                  opacity: currentPage === 1 ? "0.5" : "1",
                }}
              />
            </button>

            {/* Page Numbers */}
            {(() => {
              const pageButtons = [];
              const maxVisiblePages = 4;

              if (totalPages <= maxVisiblePages + 1) {
                for (let i = 1; i <= totalPages; i++) {
                  pageButtons.push(i);
                }
              } else {
                if (currentPage <= maxVisiblePages) {
                  for (let i = 1; i <= maxVisiblePages; i++) {
                    pageButtons.push(i);
                  }
                  pageButtons.push('...', totalPages);
                } else if (currentPage > totalPages - maxVisiblePages) {
                  pageButtons.push(1, '...');
                  for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
                    pageButtons.push(i);
                  }
                } else {
                  pageButtons.push(1, '...');
                  pageButtons.push(currentPage - 1, currentPage, currentPage + 1);
                  pageButtons.push('...', totalPages);
                }
              }

              return pageButtons.map((page, index) => {
                if (page === '...') {
                  return (
                    <span key={`ellipsis-${index}`} style={{ margin: "0 5px" }}>...</span>
                  );
                }

                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    style={{
                      margin: "0 5px",
                      padding: "5px 10px",
                      background: currentPage === page ? "#D9D9D9" : "#fff",
                      color: currentPage === page ? "black" : "#00000075",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {page}
                  </button>
                );
              });
            })()}

            {/* Next arrow */}
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                margin: "0 5px",
                padding: "5px 10px",
                background: "#fff",
                border: "none",
                cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer",
                color: currentPage === totalPages || totalPages === 0 ? "#ccc" : "#000"
              }}
            >
              <img src={arrowIcon} alt="arrow-icon"
                style={{
                  opacity: currentPage === totalPages || totalPages === 0 ? "0.5" : "1",
                  transform: 'rotateY(180deg)'
                }}
              />
            </button>
          </div>
        </div>

      </div>

      {showCreatePackage &&
        <CreatePackageInPage setShowCreatePackage={setShowCreatePackage} containerRef={containerRef} />
      }

      {showUpdatePackage &&
        <UpdatePackageInPage setShowUpdatePackage={setShowUpdatePackage} containerUpdateRef={containerUpdateRef} id={cardId} />
      }

    </div>
  );
};

export default ExpiredPackage;